import React, { useState, useCallback } from 'react';
import { InputAdornment, TextField, Button } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { Search as SearchIcon } from '@mui/icons-material';
import _ from 'lodash';
import './SubmittableSearchBar.scss';

const noop = () => { };
const debounceWait = 300;

/**
 * @param {import('@mui/material').TextFieldProps & {
 *  isTriggerSearchOnChange?: boolean;
 * }} param0
 */
const SubmittableSearchBar = ({
    className,
    onChange = noop,
    isTriggerSearchOnChange,
    ...props
}) => {
    const { t } = useTranslation('common');
    const debouncedChangeHandler = useCallback(_.debounce(onChange, debounceWait), []);

    const [searchValue, setSearchValue] = useState("");

    const handleKeyDown = (e) => {
        if (e.key === 'Enter') {
            debouncedChangeHandler(searchValue)
        }
    }

    /** @param {React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>} param0 */
    const onTextChange = ({ target: { value: searchValue } }) => {
        const isSearchOnChange = isTriggerSearchOnChange || false;

        setSearchValue(searchValue);

        if (isSearchOnChange) {
            debouncedChangeHandler(searchValue);
        }
    };

    return (
        <TextField
            size="small"
            variant="outlined"
            {...props}
            className={`${className || ''} submittable-search-bar `}
            placeholder={t('search')}
            value={searchValue}
            onChange={onTextChange}
            onKeyDown={handleKeyDown}
            InputProps={{
                startAdornment: (
                    <InputAdornment position="start">
                        <SearchIcon />
                    </InputAdornment>
                ),
                endAdornment: (
                    <InputAdornment position="end">
                        <Button
                            size="small"
                            variant="contained"
                            color="primary"
                            onClick={() => debouncedChangeHandler(searchValue)}
                        >
                            {t('search')}
                        </Button>
                    </InputAdornment>
                )
            }}
        />
    );
};

export default SubmittableSearchBar;
